import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export const useContactMessageDetails = (id) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['companyContactMessageDetails', id],
        queryFn: () =>
            api.get(`/company/contacts/${id}`).then(res => res.data),
        enabled: !!id, // Only fetch if id is provided
    });

    return {
        message: data?.data || null,
        isLoading,
        error,
    };
};

